import * as React from "react";
import { Trans } from "react-i18next";
import { ExperienceTransactionVipSubscriptionDetailsFragmentFragment } from "../../../hooks/useXPTransactions/graphql/XPTransactionsFragment.generated";

export const ExperienceTransactionVipSubscriptionDetails = ({
  details,
  earnedXP,
  totalXP,
}: {
  details: ExperienceTransactionVipSubscriptionDetailsFragmentFragment;
  earnedXP: number;
  totalXP: number;
}) => {
  return (
    <Trans
      i18nKey="xp_transaction.ExperienceTransactionVipSubscriptionDetails"
      components={{
        xp: <span className="font-bold" />,
        total: <span className="font-bold" />,
      }}
      values={{ xp: earnedXP, total: totalXP }}
    />
  );
};
